import { SemanticICONS } from "semantic-ui-react";
import moment from 'moment';

export const SORT_ORDER = {
    ASC: "asc",
    DESC: "desc"
}

interface ISort {
    DEFAULT: SemanticICONS;
    ASC: SemanticICONS;
    DESC: SemanticICONS;
}

export const SORT_ICON: ISort = {
    DEFAULT: "sort",
    ASC: "sort up",
    DESC: "sort down"
};

export function sortByNameSimple(sortOrder: any, list: any, sortName: any) {
    const sortedList = list.sort((a: any, b: any) => {
        if (a[sortName] < b[sortName]) {
            return sortOrder === SORT_ORDER.ASC ? -1 : 1
        }

        if (a[sortName] > b[sortName]) {
            return sortOrder === SORT_ORDER.ASC ? 1 : -1
        }
        return 0;
    })
    return sortedList;
}

export function sortByDate(colName: any, sortOrder: any, list: any, sortName: any, useMetaFld: boolean) {
    const sortedList = list.sort((a: any, b: any) => {
        let valA = "";
        let valB = "";

        if (useMetaFld) {
            valA = a[sortName].find((x: any) => x.fieldName === colName).recordValue;
            valB = b[sortName].find((x: any) => x.fieldName === colName).recordValue;
        } else {
            valA = a[sortName];
            valB = b[sortName];
        }

        return dateSort(valA, valB, sortOrder);
    })

    return sortedList;
}

export function sortByName(colName: any, sortOrder: any, list: any, sortName: any, useMetaFld: any) {
    const sortedList = list.sort((a: any, b: any) => {

        let valA: any = "";
        let valB: any = "";
        let sortValA: string = "";
        let sortValB: string = "";

        if (useMetaFld) {
            valA = a[sortName].find((x: any) => x.fieldName === colName).recordValue;
            valB = b[sortName].find((x: any) => x.fieldName === colName).recordValue;
        } else {
            valA = a[sortName];
            valB = b[sortName];
        }

        if (typeof valA !== "string") {
            sortValA = valA.toString();
            sortValB = valB.toString();
        } else {
            sortValA = valA;
            sortValB = valB;
        }

        if (sortOrder === SORT_ORDER.ASC) {
            return sortValA.toLowerCase().localeCompare(sortValB.toLowerCase(), undefined, { numeric: true, sensitivity: 'base' });
        }
        else if (sortOrder === SORT_ORDER.DESC) {
            return sortValB.toLowerCase().localeCompare(sortValA.toLowerCase(), undefined, { numeric: true, sensitivity: 'base' });
        }

        return 0;
    });
    return sortedList;
}

export function sortByNumber(colName: any, sortOrder: any, list: any, sortName: any, useMetaFld: any) {

    const sortedList = list.sort((a: any, b: any) => {

        let valA = 0;
        let valB = 0;
        if (useMetaFld) {
            valA = a[sortName].find((x: any) => x.fieldName === colName).recordValue;
            valB = b[sortName].find((x: any) => x.fieldName === colName).recordValue;
        } else {
            valA = a[sortName];
            valB = b[sortName];
        }

        if (sortOrder === SORT_ORDER.ASC) {
            return valA.toString().toLowerCase().localeCompare(valB.toString().toLowerCase(), undefined, { numeric: true, sensitivity: 'base' });
        }
        else if (sortOrder === SORT_ORDER.DESC) {
            return valB.toString().toLowerCase().localeCompare(valA.toString().toLowerCase(), undefined, { numeric: true, sensitivity: 'base' });
        }
        return 0;
    })

    return sortedList;
}

// sort data on click
export function requestSort(colName: any, format: any, colValName: any, setCurrentSortName: any, setSortIcon: any,
    setSortOrder: any, sortOrder: any, callback: any, list: any, useMetaFld: any) {

    setCurrentSortName(colName);
    let tempSort = SORT_ORDER.DESC;
    if (sortOrder === SORT_ORDER.ASC) {
        setSortIcon(SORT_ICON.DESC);
        setSortOrder(SORT_ORDER.DESC);
    } else {
        setSortIcon(SORT_ICON.ASC);
        setSortOrder(SORT_ORDER.ASC);
        tempSort = SORT_ORDER.ASC;
    }
    if (format.toLowerCase() === "date" || format.toLowerCase() === "datetime") {
        callback(sortByDate(colName, tempSort, list, colValName, useMetaFld));
    } else if (format.toLowerCase() === "number") {
        callback(sortByNumber(colName, tempSort, list, colValName, useMetaFld));
    }
    else {
        callback(sortByName(colName, tempSort, list, colValName, useMetaFld));
    }
}

export const dateSort = (a: any, b: any, sortOrder: string = SORT_ORDER.ASC) => {
    const strA = a ? a.toString().trim() : "";
    const strB = b ? b.toString().trim() : "";

    if (strA === "" && strB === "") return 0;
    if (strA === "") return 1;
    if (strB === "") return -1;

    // Common formats - covers 90% of use cases
    const commonFormats = [
        'DD/MM/YYYY hh:mm A', 'DD/MM/YYYY HH:mm', 'DD/MM/YYYY',
        'MM/DD/YYYY hh:mm A', 'MM/DD/YYYY HH:mm', 'MM/DD/YYYY',
        'YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD HH:mm', 'YYYY-MM-DD',
        'DD-MM-YYYY', 'MM-DD-YYYY'
    ];

    const parseFlexibleDate = (str: string) => {
        // Try common formats first
        let date = moment(str, commonFormats, true);
        if (date.isValid()) return date;

        // Fallback to automatic parsing
        date = moment(str);
        return date.isValid() ? date : moment.invalid();
    };

    const dateA = parseFlexibleDate(strA);
    const dateB = parseFlexibleDate(strB);

    if (!dateA.isValid() && !dateB.isValid()) return 0;
    if (!dateA.isValid()) return 1;
    if (!dateB.isValid()) return -1;

    const comparison = dateA.valueOf() - dateB.valueOf();
    return sortOrder === SORT_ORDER.ASC ? comparison : -comparison;
}